import React, {FC} from 'react';
import StickyToggleBtn from "./stickyToggleBtn/StickyToggleBtn"
import MenuBarCustom from '@ui/menuBarCustom/MenuBarCustom';
import {IMenuBarItem, MenuSettingsChildren} from "@ui/menuBarCustom/types";

interface IProps {
    stickyHeader?: boolean,
    setStickyHeader: (sticky: boolean) => void,
    disabled?: boolean,
    menuSettingsTable?:MenuSettingsChildren
}

const SettingsBar: FC<IProps> = ({
                                     stickyHeader,
                                     setStickyHeader,
                                     disabled,
                                     menuSettingsTable
                                 }) => {


    const items:IMenuBarItem[] = [
        {
            component: <StickyToggleBtn
                stickyHeader={stickyHeader}
                setStickyHeader={setStickyHeader}
            />,
            closeMenu: true,
        }
    ]

    return (
        <MenuBarCustom
            disabled={disabled}
            size={'small'}
            items={items}
            children={menuSettingsTable}
        />
    );
};

export default SettingsBar;